import { IMG } from "./site";

// Each service gets its own dedicated, SEO-focused page.
export const SERVICES_DATA = [
  {
    slug: "polyaspartic-garage-floors",
    name: "Polyaspartic Garage Floors",
    short: "Our toughest, fastest-curing one-day garage floor.",
    category: "Residential",
    image: IMG.blackGarage,
    gallery: [IMG.blackGarage, IMG.metallic, IMG.hexLed],
    title: "Polyaspartic Garage Floor Coatings | Prescott & Northern Arizona | PRYME EPOXY",
    metaDescription:
      "Premium one-day polyaspartic garage floor coatings in Prescott, Flagstaff and Sedona. Stronger than epoxy, UV-stable, lifetime warranty. Call Tyler for a free estimate.",
    overview: [
      "Polyaspartic is the strongest, longest-lasting garage floor system we install. It bonds deep into the concrete and forms a tough, flexible shell that shrugs off hot tires, oil, chemicals and impacts.",
      "Because it cures fast, we can grind, coat and finish most garages in a single day. You walk on it the same evening and park on it within 24 hours.",
    ],
    benefits: [
      "Four times stronger than store-bought epoxy",
      "Installed in one day, ready for cars in 24 hours",
      "UV-stable, so it never yellows in the Arizona sun",
      "Resists hot-tire pickup, oil, salt and chemicals",
      "Backed by our residential lifetime warranty",
    ],
    applications: ["Home garages", "Workshops", "Mudrooms", "Basements", "Showroom garages"],
    faqs: [
      { q: "Is polyaspartic better than epoxy?", a: "For garages in Arizona, yes. It cures faster, stays flexible, and won't yellow in the sun. We often pair it with an epoxy base for the best result." },
      { q: "How long until I can park on it?", a: "About 24 hours. You can usually walk on it the same evening we finish." },
      { q: "Will it peel like cheap kits?", a: "No. Cheap kits skip grinding. We diamond-grind the concrete so the coating bonds permanently and won't peel." },
    ],
    related: ["epoxy-garage-floors", "polyaspartic-patio-coatings", "polished-concrete"],
  },
  {
    slug: "epoxy-garage-floors",
    name: "Epoxy Garage Floors",
    short: "Industrial high-solids epoxy built for heavy use.",
    category: "Residential",
    image: IMG.hexLed,
    gallery: [IMG.hexLed, IMG.blackGarage, IMG.metallic],
    title: "Epoxy Garage Floor Coatings | Prescott, Flagstaff, Sedona | PRYME EPOXY",
    metaDescription:
      "Industrial-grade epoxy garage floor coatings across Northern Arizona. Durable, easy to clean, and beautiful. Free estimates from a trusted local contractor.",
    overview: [
      "Our epoxy floors use high-solids industrial resin, not the thin paint you find in a box store. It creates a thick, hard surface that handles heavy loads and looks fantastic.",
      "We finish most epoxy floors with a clear polyaspartic topcoat for extra protection and a deep, glossy shine that lasts.",
    ],
    benefits: [
      "Thick, high-solids industrial epoxy",
      "Resists gas, oil, impact and battery acid",
      "Easy to sweep and wipe clean",
      "Custom flake colors to match your home",
      "Sealed with a protective polyaspartic topcoat",
    ],
    applications: ["Home garages", "Hobby shops", "Storage areas", "Laundry rooms"],
    faqs: [
      { q: "How is this different from a garage floor kit?", a: "Kits are thin paint over unprepared concrete. We grind the slab and apply industrial epoxy many times thicker, so it actually lasts." },
      { q: "Can I pick the color?", a: "Absolutely. We offer a wide range of flake blends so your floor matches your style." },
      { q: "Is epoxy slippery?", a: "Our flake finish adds texture for grip. We can also add extra anti-slip if you'd like." },
    ],
    related: ["polyaspartic-garage-floors", "polished-concrete", "commercial-floor-coatings"],
  },
  {
    slug: "commercial-floor-coatings",
    name: "Commercial Floor Coatings",
    short: "Durable, low-maintenance floors that keep your business moving.",
    category: "Commercial",
    image: IMG.commercialWarehouse,
    gallery: [IMG.commercialWarehouse, IMG.commercialPaint, IMG.metallic],
    title: "Commercial Floor Coatings | Warehouses & Shops | Northern Arizona | PRYME EPOXY",
    metaDescription:
      "Heavy-duty commercial floor coatings for warehouses, retail, auto shops and facilities in Prescott, Flagstaff and Sedona. Minimal downtime, professional results.",
    overview: [
      "Your floor takes a beating every day. We install tough commercial coatings that stand up to forklifts, foot traffic, carts and chemicals while staying easy to clean.",
      "We work around your schedule to keep downtime low, and we always meet code and safety requirements.",
    ],
    benefits: [
      "Built for heavy traffic and equipment",
      "Slip-resistant safety options",
      "Dust-free and easy to maintain",
      "Professional, clean appearance",
      "Installed with minimal business downtime",
    ],
    applications: ["Warehouses", "Retail stores", "Auto shops", "Restaurants", "Manufacturing", "Aircraft hangars"],
    faqs: [
      { q: "Can you work after hours?", a: "Yes. We schedule around your operations to keep your business running with as little disruption as possible." },
      { q: "How tough are these floors?", a: "Very tough. They're designed for forklifts, pallet jacks and constant traffic without chipping or wearing through." },
      { q: "Do they meet safety codes?", a: "Yes. We use code-compliant systems and can add slip-resistant finishes for safe walking surfaces." },
    ],
    related: ["concrete-grind-and-seal", "polished-concrete", "epoxy-garage-floors"],
  },
  {
    slug: "concrete-grind-and-seal",
    name: "Concrete Grind & Seal",
    short: "A clean, dust-free, sealed concrete surface.",
    category: "Commercial",
    image: IMG.commercialPaint,
    gallery: [IMG.commercialPaint, IMG.commercialWarehouse],
    title: "Concrete Grind & Seal | Commercial & Industrial | Northern Arizona | PRYME EPOXY",
    metaDescription:
      "Professional concrete grind and seal services for shops, warehouses and facilities across Northern Arizona. Clean, dust-free, durable floors. Free estimates.",
    overview: [
      "Grind and seal is a smart, affordable way to protect bare concrete. We grind the surface smooth, then apply a high-grade sealer that locks out dust, stains and moisture.",
      "The result is a clean, professional floor that's simple to maintain and ready for heavy use.",
    ],
    benefits: [
      "Stops concrete dusting",
      "Resists stains, oil and moisture",
      "Smooth, easy-to-clean surface",
      "Cost-effective for large areas",
      "Great for shops and warehouses",
    ],
    applications: ["Warehouses", "Workshops", "Storage facilities", "Loading docks"],
    faqs: [
      { q: "What is concrete dusting?", a: "Bare concrete sheds a fine powder over time. Grinding and sealing stops that, so your space stays cleaner." },
      { q: "Is this cheaper than a full coating?", a: "Often yes. It's a great value for large industrial areas that need protection without a full coating system." },
      { q: "How long does it last?", a: "With proper maintenance, a sealed floor lasts for years. We can reseal high-traffic areas as needed." },
    ],
    related: ["polished-concrete", "commercial-floor-coatings", "polyaspartic-garage-floors"],
  },
  {
    slug: "polished-concrete",
    name: "Polished Concrete",
    short: "A glossy, durable, low-maintenance polished floor.",
    category: "Commercial",
    image: IMG.commercialWarehouse,
    gallery: [IMG.commercialWarehouse, IMG.roundRoom],
    title: "Polished Concrete Floors | Commercial & Retail | Northern Arizona | PRYME EPOXY",
    metaDescription:
      "Polished concrete floors for retail, offices and warehouses in Prescott, Flagstaff and Sedona. Glossy, durable and easy to maintain. Call Tyler for a free quote.",
    overview: [
      "Polished concrete gives you a sleek, glossy floor without coatings or wax. We use a multi-step diamond polishing process and a chemical densifier to harden the surface.",
      "It's a favorite for retail and offices because it looks high-end, lasts a long time, and is incredibly easy to maintain.",
    ],
    benefits: [
      "High-gloss, modern look",
      "Extremely durable and hard",
      "Low maintenance, no waxing",
      "Reflects light to brighten spaces",
      "Long-lasting value",
    ],
    applications: ["Retail stores", "Showrooms", "Offices", "Warehouses", "Restaurants"],
    faqs: [
      { q: "Does polished concrete need sealing?", a: "We densify and polish the slab so it's naturally hard and stain-resistant. For some uses we add a guard for extra protection." },
      { q: "How shiny can it get?", a: "From a soft satin sheen to a high-gloss mirror finish. You choose the look you want." },
      { q: "Is it slippery?", a: "Polished concrete has good traction when dry. We can add slip-resistant treatments for wet areas." },
    ],
    related: ["concrete-grind-and-seal", "commercial-floor-coatings", "epoxy-garage-floors"],
  },
  {
    slug: "polyaspartic-patio-coatings",
    name: "Polyaspartic Patio Coatings",
    short: "Beautiful, UV-stable coatings made for the outdoors.",
    category: "Residential",
    image: IMG.roundRoom,
    gallery: [IMG.roundRoom, IMG.metallic],
    title: "Polyaspartic Patio Coatings | Outdoor Concrete | Northern Arizona | PRYME EPOXY",
    metaDescription:
      "UV-stable polyaspartic patio coatings built for the Arizona sun. Beautiful, slip-resistant and long-lasting. Serving Prescott, Sedona and Flagstaff.",
    overview: [
      "Your patio deserves the same quality as your garage. Our polyaspartic patio coatings are UV-stable, so they won't fade or yellow even under the strong Arizona sun.",
      "We finish them with a textured, slip-resistant surface that stays comfortable underfoot and easy to clean.",
    ],
    benefits: [
      "UV-stable, won't yellow or fade",
      "Slip-resistant textured finish",
      "Handles heat, rain and freeze cycles",
      "Easy to sweep and rinse clean",
      "Adds beauty and value outdoors",
    ],
    applications: ["Back patios", "Pool decks", "Walkways", "Porches", "Outdoor kitchens"],
    faqs: [
      { q: "Will the sun fade my patio coating?", a: "No. Polyaspartic is UV-stable, which means it keeps its color in full sun where cheaper coatings turn yellow." },
      { q: "Is it slippery when wet?", a: "We add a textured, slip-resistant finish so it stays safe around pools and in the rain." },
      { q: "Can it handle our freeze-thaw winters?", a: "Yes. It stays flexible and bonds tightly, so it handles Northern Arizona's temperature swings well." },
    ],
    related: ["polyaspartic-garage-floors", "polished-concrete", "concrete-grind-and-seal"],
  },
];

export const getService = (slug) => SERVICES_DATA.find((s) => s.slug === slug);
